import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import toast from "./toast";

export default combineReducers({
  form: formReducer,
  toast,
});
